import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { fetchEmployerDetailbyID } from "../../api/EmployerAPI";
import "../../assets/css/availabilityStatus.css";


export default function HrProfile() {
  const [isEditing, setIsEditing] = useState(false);
  const [employerDet, setEmployerDet] = useState([]);
  const [message, setMessage] = useState({ type: "", text: "" });
  const appUserId = localStorage.getItem("aUId");
  const token = localStorage.getItem("otoken");
  const fullName = localStorage.getItem("name");
  const profilePic = localStorage.getItem("profilePic");
  const navigate = useNavigate();
  const availabilityLabels = {
  "available": "Available",
  "donotdisturb": "Do Not Disturb",
  "onleave": "On Leave",
};

  const formData = {
    fullName: "John Doe",
    designation: "HR Manager",
    email: "johndoe@example.com",
    phone: "+1 123 456 7890",
    linkedin_url: "linkedin_url.com/rin/johndoe",
    username: "johndoe",
    notifications: {
      email: true,
      sms: true,
      inApp: true,
    },
    availability: "Available",
  };

//   useEffect(() => {
//   const testFetch = async () => {
//     const id = localStorage.getItem("aUId"); // or use a dummy like "123"
//     const token = localStorage.getItem("token"); // or a hardcoded one temporarily

//     if (id && token) {
//       await fetchEmployerDetailbyID(id, token);
//     } else {
//       console.warn("Missing ID or Token");
//     }
//   };

//   testFetch();
// }, []);
useEffect(() => {
  const appUserId = localStorage.getItem("aUId");
  const token = localStorage.getItem("otoken");

  if (!appUserId || !token) {
    console.warn("User ID or token missing");
    return;
  }

  const fetchData = async () => {
    console.log("Calling fetchEmployerDetailbyID");
    try {
      const data = await fetchEmployerDetailbyID(appUserId, token);
      setEmployerDet(data);
    } catch (error) {
      console.error("API failed:", error);
      setMessage({ type: "error", text: "Could not load profile" });
    }
  };

  fetchData();
}, []);



  
    // const logoUrl = companies.company_logo
    //   ? `${process.env.REACT_APP_JOB_BOARD_UPLOAD_URL}/${companies.company_logo}`
    //   : null;
  
    // console.log(logoUrl);
console.log("employerDet.employer : ",employerDet);
  return (
    <div className="content-body">
      <div className="row page-titles mx-0">
        <div className="col p-md-0">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="javascript:void(0)">Dashboard</a>
            </li>
            <li className="breadcrumb-item active">
              <a href="javascript:void(0)">Home</a>
            </li>
          </ol>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-xl-12">
            
            <div className="card">
             {message.text && <div className={`alert alert-${message.type} mt-3`} role="alert">
                        {message.text}
              </div>
            }
              <div className="card-body">
                
                <div className="d-flex justify-content-end mb-3">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    title="Edit"
                    onClick={() =>
                     navigate(`/employer/profile-management/edit/${appUserId}`, {
                        state: { employerDet }
                      })

                    }
                  >
                    <i className="fa fa-pencil-square"></i>
                  </button>
                </div>

                <div className="mx-auto bg-white rounded-xl shadow-md p-5" style={{ maxWidth: "700px" }}>
                  <div className="d-flex align-items-center mb-4">
                    <div
                        className="bg-light d-flex align-items-center justify-content-center rounded-circle overflow-hidden"
                        style={{
                          width: "100px",
                          height: "100px",
                          borderRadius: "50%", // 🔴 Makes the shape round
                          overflow: "hidden",  // 🔒 Clips the image inside the circle
                          backgroundColor: "#f0f0f0", // fallback background
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {profilePic ? (
                          <img
                            src={profilePic}
                            alt="Profile"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <i className="fa fa-user text-muted fa-2x" />
                        )}
                    </div>

                    <div className="ml-4">
                      
                      <h3 className="mb-1">{fullName}</h3>
                      <p className="text-muted mb-0">{employerDet?.employer?.designation}</p>
                    </div>
                  </div>

                  <h5 className="font-weight-bold mb-3">Company Detail</h5>
                  <div className="mb-2">
                    <strong>Name:</strong> {employerDet?.company?.company_name}
                  </div>

                  <h5 className="font-weight-bold mt-4 mb-3">Contact Information</h5>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2">
                      <strong>Mobile:</strong> {employerDet?.employer?.phone_number}
                    </li>
                    <li className="mb-2">
                      <strong>Email:</strong> {employerDet?.employer?.email}
                    </li>
                    <li className="mb-2">
                      <strong>LinkedIn:</strong>{" "}
                      <a
                        href={`${employerDet?.employer?.linkedin_url}`}
                        className="text-primary"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {employerDet?.employer?.linkedin_url}
                      </a>
                    </li>
                  </ul>

                  {/* <h5 className="font-weight-bold mb-3">Account Settings</h5>
                  <div className="mb-2">
                    <strong>Username:</strong> {employerDet?.employer?.email}
                  </div>
                  <div className="mb-4">
                    <strong>Password:</strong> ********
                  </div> */}

                  <div className="mb-4">
                    <strong>Notification Preferences:</strong>
                    <ul className="list-inline mt-2">
                      {employerDet?.employer?.email_notification  === "yes" && <li className="list-inline-item badge badge-info mr-2">Email</li>}
                     
                      {employerDet?.employer?.in_app_notification  === "yes" && <li className="list-inline-item badge badge-warning">In-app</li>}
                    </ul>
                  </div>

                   <div>
                    <strong>Availability Status:</strong>{" "}
                    <span className={`activity ${employerDet?.employer?.availability_status?.toLowerCase().replace(/\s+/g, '-')}`}></span>{" "}
                    {availabilityLabels[employerDet?.employer?.availability_status?.toLowerCase()] || "Unknown"}
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
